import React from 'react';

import { RadioGroupVariant } from '../../types/RadioGroupTypes';

import {
  FieldContainer,
  RadioButtonsWrapper,
  StyledRadio,
  StyledRadioGroup
} from '../InformedRadioGroup/styledComponent';

interface RadioOptionTypes {
  label: string | number;
  value: string | number;
}

interface RadioGroupTypes {
  defaultValue?: string;
  onChange?: (e: any) => void;
  labelClassName?: string;
  type: RadioGroupVariant;
  hideRadioButtons?: boolean;
  radioButtonPosition?: string;
  field: string;
  error?: string;
  touched: boolean;
  label?: string;
  radioOptions?: Array<RadioOptionTypes>;
  validationSchemaObject?: any;
  validateOnBlur?: true;
  validateOnChange?: true;
  radioButtonClassName?: string;
  radioGroupClassName?: string;
  radioClassName?: string;
  isHidden?: boolean;
  fieldWrapperStyles?: React.CSSProperties;
  radioWrapperStyles?: React.CSSProperties;
  isDisabled?: boolean;
  hintClassName?: string;
  children?: any;
  isMarginBottomZero?: boolean;
  value?: string;
}

export function RadioGroup(props: RadioGroupTypes) {
  const {
    labelClassName,
    type,
    defaultValue,
    hideRadioButtons,
    radioButtonPosition,
    radioOptions: informedRadioOptions = [],
    radioGroupClassName,
    radioButtonClassName,
    label,
    validationSchemaObject,
    fieldWrapperStyles,
    radioClassName = 'mr-4',
    radioWrapperStyles,
    isHidden,
    field,
    isDisabled,
    hintClassName,
    children,
    isMarginBottomZero,
    onChange,
    error,
    value,
    ...otherProps
  } = props;

  const onChangeFunction = (e: any) => {
    onChange && onChange(e);
  };

  return (
    <FieldContainer
      isHidden={isHidden}
      css={fieldWrapperStyles}
      isMarginBottomZero={isMarginBottomZero}
    >
      <StyledRadioGroup
        value={value}
        type={type}
        label={label}
        className={radioGroupClassName}
        onChange={(e) => {
          onChangeFunction(e);
        }}
        labelClassName={labelClassName}
        defaultValue={defaultValue}
        errorMessage={error}
        hintClassName={hintClassName}
      >
        {children ? (
          children
        ) : (
          <RadioButtonsWrapper css={radioWrapperStyles}>
            {informedRadioOptions.map((option, index) => (
              <StyledRadio
                key={option.value}
                value={option.value}
                radioButtonClassName={radioButtonClassName}
                className={radioClassName}
                isDisabled={isDisabled}
              >
                {option.label}
              </StyledRadio>
            ))}
          </RadioButtonsWrapper>
        )}
      </StyledRadioGroup>
    </FieldContainer>
  );
}
